import {Box} from '@mantine/core';
import type {PropsWithChildren} from 'react';
import {MdArrowForwardIos} from 'react-icons/md';
import {COLOR_BLACK_1} from '../../../config/constants/colorCodes';
import {GoogleAdBannerName} from '../../../config/constants/googleAdBanner';
import {COMMUNITY, HOME} from '../../../config/constants/routes';
import {GoogleAdBanner} from '../../../shared/components/Banner/GoogleAdBanner';
import {CommonLink} from '../../../shared/components/CommonLink';
import {GeneralFooter} from '../../../shared/components/Footer/general';
import {GeneralHeaderContainer} from '../../../shared/components/Header/General/container';
import {useIsAppWebView} from '../../../shared/hooks/useIsAppWebView';
import {useGoogleAdBanner} from '../../../shared/services/useGoogleAdBanner';
import {useMediaQuery} from '../../../shared/services/useMediaQuery';
import {FollowingTopicList} from './Container/FollowingTopicList';

export const CommunityLayout = ({children}: PropsWithChildren) => {
  const isWebView = useIsAppWebView();
  const {isPC} = useMediaQuery();

  // DFPバナーのセット
  const googleAdBannerNames = [
    GoogleAdBannerName.B_RECTANGLE,
    GoogleAdBannerName.B_RECTANGLE_BOTTOM,
  ];
  useGoogleAdBanner(googleAdBannerNames);

  return (
    <>
      <div>
        {!isWebView && <GeneralHeaderContainer />}
        <main>
          <Box className="flex min-h-screen flex-col items-center bg-background-1 py-12 pc:py-32">
            <div className="mx-auto my-0 max-w-[1200px]">
              <GoogleAdBanner
                googleAdBannerName={GoogleAdBannerName.RICH_DESKTOP_HEADER}
              />
              {/* パンくずリスト */}
              {isPC && (
                <div className="w-full flex justify-start items-center">
                  <CommonLink
                    href={HOME}
                    className="text-base text-link leading hover:opacity-80"
                  >
                    HOME
                  </CommonLink>
                  <p className="px-8">
                    <MdArrowForwardIos size={12} fill={COLOR_BLACK_1} />
                  </p>
                  <CommonLink
                    href={COMMUNITY}
                    className="text-base text-link leading hover:opacity-80"
                  >
                    コミュニティ
                  </CommonLink>
                </div>
              )}
              <div className="flex justify-between mt-16">
                {/* 左・中央カラム */}
                {children}
                {/* 右カラム */}
                {isPC && (
                  <Box className="w-[300px] ml-16 sticky">
                    <div className="h-[250px]">
                      <GoogleAdBanner
                        googleAdBannerName={GoogleAdBannerName.B_RECTANGLE}
                      />
                    </div>
                    <div className="mt-16">
                      <FollowingTopicList />
                    </div>
                    <div className="mt-16 h-[250px]">
                      <GoogleAdBanner
                        googleAdBannerName={
                          GoogleAdBannerName.B_RECTANGLE_BOTTOM
                        }
                      />
                    </div>
                  </Box>
                )}
              </div>
            </div>
          </Box>
        </main>
        {!isWebView && <GeneralFooter />}
      </div>
    </>
  );
};
